import Vue from 'vue';

const ToastBus = new Vue();

export default {
  install(VueInstance) {
    VueInstance.prototype.$toast = {
      show(
        message,
        type = 'default',
        duration = 5000,
        hasAllowRej = false,
        onAllow,
        onReject,
        data = null,
        handleId = null
      ) {
        ToastBus.$emit('show-toast', {
          message,
          type,
          duration,
          hasAllowRej,
          onAllow,
          onReject,
          data,
          handleId,
        });
      },
      close(id) {
        ToastBus.$emit('close-toast', {
          id,
        });
      },
    };
    VueInstance.prototype.$toastBus = ToastBus;
  },
};
